import { useFlag } from 'utils/launchdarkly';

export default function useCanUseApplePay() {
  const applePayPluginAvailable = useFlag('enable-apple-pay');
  let canMakePayments = false;
  if (window.ApplePaySession) {
    try {
      canMakePayments = ApplePaySession.canMakePayments();
    } catch {
      canMakePayments = false;
    }
  }
  return canMakePayments && applePayPluginAvailable;
}
